import AlertMassage from "./AlertMassage";
export default AlertMassage;